module.exports = __webpack_public_path__ + "static/media/cb_logo.0ae24538.png";